import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

import { IStorage } from 'src/app/_types/i-storage.type';

@Injectable()
export class SessionStorageService implements IStorage {
  protected subjectMap: Map<string, BehaviorSubject<any>> = new Map();

  select(key: string, defaultValue: any = null): Observable<any> {
    if (this.subjectMap.has(key)) {
      return this.subjectMap
        .get(key)
        .asObservable()
        .pipe(delay(1));
    }

    const rawValue = window.sessionStorage.getItem(key);
    const parsedvalue = rawValue ? JSON.parse(rawValue) : defaultValue;
    if (!rawValue && defaultValue) {
      window.sessionStorage.setItem(key, JSON.stringify(parsedvalue));
    }

    const subject = new BehaviorSubject(parsedvalue);
    this.subjectMap.set(key, subject);

    return subject.asObservable().pipe(delay(1));
  }

  set(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
    if (this.subjectMap.has(key)) {
      this.subjectMap.get(key).next(value);
    }
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key);
    if (this.subjectMap.has(key)) {
      this.subjectMap.get(key).next(null);
    }
  }

  clear(): void {
    window.sessionStorage.clear();
    this.subjectMap.forEach(subject => {
      subject.complete();
      subject.unsubscribe();
    });
    this.subjectMap = new Map();
  }
}
